import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
/**
 *
 * @param {string} name
 * @param {string} time
 * @param {string} content
 * @param {[{img: JSX.Element, type: string img | video}]} thumbnail
 * @param {JSX.Element} characterImg
 * @returns
 */
const Character = ({ idx, category, title, articleNo }) => {
  const { i18n } = useTranslation();

  return (
    <Link
      to={`/${i18n.language}/devlog/withBTS/${articleNo}`}
      key={`dev_${idx}`}
    >
      <ul className=" devnote-text  text-sm xs:text-md font-notoSans m-auto  ">
        <li className="relative" key={`dev_li_${idx}`}>
          <div className="text-center books-img  flex justify-center items-center">
            <img
              src={`/img/v2/withbts/devnote/devnote_${idx}_${category}.png`}
              alt=""
              className="relative normal-books "
            />
            <div className="absolute top-0 left-0 right-0 bottom-0 absolute-books ">
              <img
                src={`/img/v2/withbts/devnote/devnote_${idx}_${category}.png`}
                alt=""
                className=" m-auto "
              />
            </div>
          </div>
        </li>
        <li className="inline-block w-full text-ellipsis overflow-hidden text-[#3d3d3d]">
          {category}
        </li>
        <li className="max-w-[200px] h-[50px] px-2 inline-block w-full  truncate text-ellipsis overflow-hidden text-[#3d3d3d]">
          {title}
        </li>
      </ul>
    </Link>
  );
};

export default Character;
